var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.5,7h-2.5v-.5c0-2.054-1.388-3.847-3.375-4.358-.264-.068-.54.092-.609.359-.069.268.092.54.36.609,1.545.397,2.625,1.792,2.625,3.39v12.5H3.5c-1.378,0-2.5-1.121-2.5-2.5v-4c0-.276-.224-.5-.5-.5s-.5.224-.5.5v4c0,1.499.952,2.771,2.28,3.268-.179.387-.28.802-.28,1.232,0,1.654,1.346,3,3,3s3-1.346,3-3c0-.344-.064-.68-.18-1h8.359c-.116.32-.18.656-.18,1,0,1.654,1.346,3,3,3s3-1.346,3-3c0-.429-.101-.844-.28-1.232,1.328-.498,2.28-1.769,2.28-3.268v-5c0-2.481-2.019-4.5-4.5-4.5Zm0,1c1.93,0,3.5,1.57,3.5,3.5v1.5h-6v-5h2.5Zm-12.5,13c0,1.103-.897,2-2,2s-2-.897-2-2c0-.361.122-.705.314-1.019.063.003.122.019.186.019h3.196c.185.309.304.646.304,1Zm14,0c0,1.103-.897,2-2,2s-2-.897-2-2c0-.354.119-.691.304-1h3.196c.064,0,.123-.015.186-.019.192.314.314.657.314,1.019Zm-.5-2h-3.5v-5h6v2.5c0,1.379-1.122,2.5-2.5,2.5ZM2.5,10h6c1.378,0,2.5-1.121,2.5-2.5V2.5c0-1.379-1.122-2.5-2.5-2.5H2.5C1.122,0,0,1.121,0,2.5v5c0,1.379,1.122,2.5,2.5,2.5ZM1,2.5c0-.827.673-1.5,1.5-1.5h6c.827,0,1.5.673,1.5,1.5v5c0,.827-.673,1.5-1.5,1.5H2.5c-.827,0-1.5-.673-1.5-1.5V2.5Zm3,1c0-.276.224-.5.5-.5h2c.276,0,.5.224.5.5s-.224.5-.5.5h-2c-.276,0-.5-.224-.5-.5Z",
    fill: "#2C5363"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourier);
export default __webpack_public_path__ + "static/media/courier.92606e297b7d5fa3d0d9b46a09043180.svg";
export { ForwardRef as ReactComponent };